import { AccessLevel } from "./asset-access";
import { BaseModel } from "./base";
import { Label } from "./label";

export class CreateFolder {
    name: string = null;
    description: string = null;
}

export class Owner {
    id: string = null;
    login: string = null;
    title?: any = null;
    firstName?: string = null;
    lastName?: string = null;
    email: string = null;
    profileImage: string = null;
}

export class Shared {
    assigneeType: string = "User";
    role: string = 'Editor';
    note: string = null;
    notify: boolean = true;
    assigneeIds: string[] = [];

}

export class Note {
    id: string = null;
    comment: string = null;
}

export class AssetFilter {
    modifiedAt = 'any'
    fileType = 'any'
    labels = 'any'
}

export class activity extends BaseModel {
    accountId: string = null;
    resourceId: string = null;
    createdBy : MinUserObj = new MinUserObj();
    actionType: string = null;
    actionObject: string = null;
    actionOutcome: string = null;
    createdAt: string = null;
    owner: Owner = new Owner();
}

export class ActivityDes {
    ITEM_MOVED = 'moved the item';
    ITEM_SHARED = 'Item shared with';
    ITEM_UPLOADED = "uploaded an item";
    ITEM_RENAMED = 'renamed the item to New Name Here';
    ITEM_TRASHED = "moved the item to the trash";
    ITEM_RESTORED = "restored the item from trash";
    ITEM_DELETED = "deleted item permanently";
    ITEM_UPDATED = 'updated item';
    ITEM_VERSION_UPDATED = "uploaded a new version of the file";
    ITEM_DUPLICATED = "make item duplicated";
    ITEM_DOWNLOADED = "downloaded an item";
    MARKED_FAVOURITE = "starred the item";
    UN_MARKED_FAVOURITE = "has unstarred the item";
    NOTE_ADDED = 'added a note';
    NOTE_EDITED = 'edit a note';
    NOTE_DELETED = "Dleeted a note";
    LABEL_ADDED = "added label";
    LABEL_UPDATED = "updated label";
    LABEL_REMOVED = "removed label";
    FOLDER_CREATED = "created folder";
    ACCESS_CHANGED_TO_VIEWER = "access change to viewer";
    ACCESS_CHANGED_TO_EDITOR = "access change to editor";
    ACCESS_CHANGED_TO_ADMIN = "access change to admin";
    ACCESS_CHANGED_TO_SUPERADMIN = "access change to superadmin";
    ITEM_ACCESS_REMOVED = "access change to removed"
    LOCK_ACQUIRED = "locked the item";
    LOCK_RELEASED = "unlocked the item";
}

// New Asset Model //FIX ME
export class Asset {
    id: string=null;
    account: Account=new Account();
    createdBy: MinUserObj=new MinUserObj() ;
    updatedBy: MinUserObj=new MinUserObj();
    createdDate: string=null;
    updatedDate?: any=null;
    deleted: boolean=null;
    parent: Parent =new Parent();
    name: string=null;
    description?: any=null;
    size: number=null;
    fileType: string=null;
    type: 'FILE'|'FOLDER'|'ROOT'=null;
    contentType?: any=null;
    status?: any=null;
    searchTags?: any=null;
    favourite:boolean=false; //fixme
    owner:Owner=new Owner() //fixme
    extension:string=null 
    labels : Label[] = [];
    accessLevel:AccessLevel=null
    lockDetail:AssetLocksHistory=null
    locked:boolean=null
    thumbnail : string = null;
    deletable:boolean = null;
    accessCount:number=null;
    parsingProgress: 'Completed' | 'InProgress' | 'Pending' = null;
    parsingPercentage: number = null;
  }
  
  export class Parent {
    id: string;
    name: string;
    description: string;
    status?: any;
    createdDate: string;
    updatedDate?: any;
    size: number;
    fileType?: any;
    type: string;
    contentType?: any;
    searchTags?: any;
    extension:string;
  }
  
  export class MinUserObj {
    id: string;
    firstName: string;
    lastName: string;
    title?: any;
    type?: any;
    name?: any;
    email: string;
    phone?: any;
    profilePic?: any;
    active: boolean;
    userType : string;
  }
  
  export class Account {
    id: string;
    name: string;
    title?: any;
    status?: any;
    createdDate?: any;
  }

  export class FileUploadError{
    type: string;
    title: string;
    status: number;
    detail: string;
    instance: string;
    properties?: any;
  }

  export class AssetLocksHistory {
    id: string = ""
    deleted: boolean = null
    createdBy: MinUserObj;
    createdDate: Date = null;
    updatedDate: Date = null
    asset: any = null
    lock: any;
    lockInstant: any = null
    userId:string=null
    firstName : string = null;
    lastName : string = null;
  }

  export interface FileUploadOptions {
    folderId?: string | null;
    replace?: boolean;
    matterId: number;
    contactId: string;
  }

  export class AssetPathItem {
    id: string;
    name: string;
    color: any;
    access: any;
    deletable: boolean;
  }